import { NgModule } from '@angular/core';
import { TOKENS } from '@trustedshops/tswp-core-notifications';
import { NotificationSettingsServiceImpl } from './services/notification-settings.service';

/**
 * Provides the notification services.
 *
 * The carrier must also bind `TOKENS.NotificationSettingsServiceConfig` to a
 * `NotificationSettingsConfig` carrying the notification API base path for the
 * stage, and list that base path among its protected endpoints so the platform
 * HTTP client attaches the bearer token.
 */
@NgModule({
  providers: [
    {
      provide: TOKENS.NotificationSettingsService,
      useClass: NotificationSettingsServiceImpl,
    },
  ],
})
export class TswpCoreNotificationsModule {}
